import React from "react";
import {
  FaLaptopCode,
  FaProjectDiagram,
  FaCoins,
  FaShoppingCart,
  FaExchangeAlt,
  FaLightbulb,
} from "react-icons/fa";

function TONFeature({ icon: Icon, title, description }) {
  return (
    <div className="services-style-four-item fade-up-anim">
      <div className="icon" style={{ fontSize: "40px", color: "#000" }}>
        <Icon />
      </div>
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  );
}

function TONDApp() {
  const features = [
    {
      title: "TON DApp Development",
      description:
        "We build high-performance DApps on TON, taking full advantage of its sharding capabilities and fast transaction processing to ensure a smooth, scalable user experience.",
      icon: FaLaptopCode,
    },
    {
      title: "Smart Contract Development",
      description:
        "Our skilled developers design secure and reliable smart contracts using TON’s unique architecture, ideal for automated business logic across diverse applications.",
      icon: FaProjectDiagram,
    },
    {
      title: "TON Token Development",
      description:
        "Whether you need utility tokens, security tokens, or NFTs, our TON token development services create tokenized assets to facilitate seamless transactions and rewards.",
      icon: FaCoins,
    },
    {
      title: "NFT Marketplace Development",
      description:
        "We specialize in creating NFT marketplaces on TON, supporting multi-chain compatibility, rapid transactions, and secure asset transfers for digital collectibles.",
      icon: FaShoppingCart,
    },
    {
      title: "Cross-Chain Bridge Development",
      description:
        "Our cross-chain bridge solutions allow interoperability with other networks, enhancing the flexibility and usability of your TON-based applications.",
      icon: FaExchangeAlt,
    },
    {
      title: "TON Consulting and Strategy",
      description:
        "Our TON experts provide consulting and strategic guidance, helping you leverage the TON network’s unique features to align with your business goals.",
      icon: FaLightbulb,
    },
  ];

  return (
    <div className="team-single-area default-padding">
      <div className="container">
        <div className="team-single-items">
          <div className="row">
            <div className="col-lg-5 left-info">
              <div className="thumb fade-up-anim">
                <img
                  src="https://validthemes.net/site-template/robok/assets/img/team/5.jpg"
                  alt="Thumb"
                />
              </div>
            </div>
            <div className="col-lg-7 right-info pl-30 pl-md-15 pl-xs-15">
              <div className="container">
                <div className="col-lg-12">
                  <div className="site-heading">
                    <h4 className="sub-title">Our Services</h4>
                    <h2 className="title split-text-right split-text-in-right split-lines">
                      Xeer’s TON Blockchain Development Services
                    </h2>
                  </div>
                </div>
              </div>
              <div className="container">
                <div className="services-style-four-items">
                  {features.map((feature, idx) => (
                    <TONFeature key={idx} {...feature} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TONDApp;
